const Utils = require("common/Utils");

function VPNConfigDownloadView() {
    var resource;

    const $content = $(require("html!./vpn_config_downloads_view.html"));
    const vpnFileLink = $content.find("#vpnFileLink");
    const mobileconfigLink = $content.find("#mobileconfigLink");
    $content.find("#vpnProfileMessage").text($.t("web::vpnConfig.message.vpnfile", {vpnProductName : Utils.getVpnProductName()}));

    /**
     * @override
     * @inheritDoc
     */
    this.getHashName = function() {
        return "VPNConfigDownload";
    };

    /**
     * @override
     * @inheritDoc
     */
    this.getHeaderConfiguration = function() {
        return {
            title : resource.name
        };
    };

    /**
     * @override
     * @inheritDoc
     */
    this.getContent = function() {
        return $content;
    };

    this.resize = function(width, height) {
        $content.height(height);
        $content.width(width);
    };

    /**
     * @override
     * @inheritDoc
     */
    this.getDisplayMode = function() {
        return "menu";
    };

    this.setResource = function(res) {
        resource = res;
        mobileconfigLink.attr("href", "/sslvpn_config/vpn/ipsec/" + res.id);
        vpnFileLink.attr("href", "/sslvpn_config/vpn/tina/" + res.id);
    };

    /**
     * @override
     * @inheritDoc
     */
    this.isLeafView = function() {
        return true;
    };
}

VPNConfigDownloadView.prototype = require("common/AbstractView");

module.exports = VPNConfigDownloadView;


//////////////////
// WEBPACK FOOTER
// ./downloads/VPNConfigDownloadView.js
// module id = 104
// module chunks = 0